import { Box, Container, Grid, Typography } from '@mui/material'
import { SECTION_DARK } from '../theme'

interface ChallengeItem {
    heading: string
    body: string
}

interface ChallengesSectionProps {
    title: string
    subtitle: string
    items: ChallengeItem[]
    color: string
}

export function ChallengesSection({ title, subtitle, items, color }: ChallengesSectionProps) {
    return (
        <Box sx={{ ...SECTION_DARK }}>
            <Container maxWidth="lg">
                <Typography variant="h2" sx={{ color: 'white', textAlign: 'center', mb: 2 }}>
                    {title}
                </Typography>
                <Typography sx={{ color: 'rgba(255,255,255,0.5)', textAlign: 'center', mb: 8, maxWidth: 540, mx: 'auto' }}>
                    {subtitle}
                </Typography>
                <Grid container spacing={3}>
                    {items.map((item, i) => (
                        <Grid item xs={12} md={4} key={i}>
                            <Box sx={{
                                background: 'rgba(255,255,255,0.04)',
                                border: `1px solid ${color}30`,
                                borderTop: `3px solid ${color}`,
                                borderRadius: 2,
                                p: 3.5,
                                height: '100%',
                            }}>
                                <Box sx={{
                                    width: 32, height: 32, borderRadius: '50%',
                                    backgroundColor: `${color}20`,
                                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                                    mb: 2,
                                }}>
                                    <Typography sx={{ color: color, fontWeight: 800, fontSize: '15px' }}>{i + 1}</Typography>
                                </Box>
                                <Typography sx={{ color: 'white', fontWeight: 700, fontSize: '15px', mb: 1.5, lineHeight: 1.5 }}>
                                    {item.heading}
                                </Typography>
                                <Typography sx={{ color: 'rgba(255,255,255,0.55)', fontSize: '14px', lineHeight: 1.7 }}>
                                    {item.body}
                                </Typography>
                            </Box>
                        </Grid>
                    ))}
                </Grid>
            </Container>
        </Box>
    )
}
